module.exports = __webpack_public_path__ + "img/skillset-decor.07e1f0b0.png";